import { flow, makeObservable, observable } from 'mobx'

import { notification } from 'services'
import { uniqBy } from 'utils'
import { UserApi } from 'api'

import BaseTasksStore from '../BaseTasksStore'

const defaultConfig = {
  statuses: [],
  assignees: [],
  projects: [],
}

const initialSelectedFilters = {
  statuses: [],
  assignees: [],
  projects: [],
}

export default class TasksCreatedStore extends BaseTasksStore {
  configLoaded = false

  constructor() {
    super()

    this.settingsKey = 'tasks-created'
    this.selectedFilters = JSON.parse(JSON.stringify(initialSelectedFilters))
    this.initialSelectedFilters = initialSelectedFilters

    makeObservable(this, {
      configLoaded: observable,
      loadIssues: flow.bound,
      loadMoreIssues: flow.bound,
      loadConfig: flow.bound,
    })

    this.applySavedFilters()
  }

  *loadIssues() {
    this.issuesLoading = true
    this.issuesLoaded = false

    try {
      const { data, currentPage, totalPages } = yield UserApi.getCreatedTasks(this.getListParams())

      this.issues = data.data

      this.pagination.setCurrentPage(currentPage)
      this.pagination.totalPages = totalPages
    } catch (ex: any) {
      notification.error('Ошибка загрузки задач')
      console.log(ex?.message)
    } finally {
      this.issuesLoading = false
      this.issuesLoaded = true
    }
  }

  *loadMoreIssues() {
    const isEndOfData = this.pagination.currentPage > this.pagination.totalPages

    if (!isEndOfData && !this.loadingMore) {
      this.loadingMore = true

      try {
        const { data, currentPage } = yield UserApi.getCreatedTasks(this.getListParams())

        this.issues = uniqBy('id', [...this.issues, ...data.data])
        this.pagination.setCurrentPage(currentPage)
      } catch (ex: any) {
        notification.error('Ошибка загрузки задач')
        console.log(ex?.message)
      } finally {
        this.loadingMore = false
      }
    }
  }

  *loadConfig() {
    this.loading = true
    try {
      const { data } = yield UserApi.getCreatedFilters()
      this.config = data.data || defaultConfig
      this.users = this.config.assignees
    } catch (ex: any) {
      console.log(ex?.message)
    } finally {
      this.loading = false
      this.configLoaded = true
    }
  }
}
